/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {ApplicationState} from '@/types/redux';

export const selectGroupChooser = ({
  globalGroup: {
    accountHierarchy,
    globalGroupId,
    globalGroup,
    groupChooser : {
      isViewing: openChooser
    }
  }
}: ApplicationState) => ({
  accountHierarchy,
  globalGroup,
  globalGroupId,
  groupChooser : {
    isViewing : openChooser
  }
});

export const groupChooserSelector =
  createDeepEqualSelector([selectGroupChooser], (data) => data);
